<dt-modal-content size="small" (closeClick)="close()" [showFooter]="done">
  <ng-template #title i18n>Passwort zurücksetzen</ng-template>
  <ng-template #content>
    @if (done) {
      <p i18n>Dein Passwort wurde erfolgreich geändert! Du kannst Dich jetzt mit dem neuen Passwort einloggen.</p>
    } @else {
      @switch (tokenStatus) {
        @case ('checking') {
          <p i18n>Überprüfe Token…</p>
        }
        @case ('invalid-simple') {
          <mat-error class="dt-error" i18n
            >Der angegebene Link ist ungültig. Stell sicher, dass der Link vollständig kopiert wurde.</mat-error
          >
        }
        @case ('invalid-server') {
          <mat-error class="dt-error" i18n>Der angegebene Link ist ungültig. Versuche es erneut.</mat-error>
        }
        @case ('rate-limit') {
          <mat-error class="dt-error" i18n
            >Du hast in kurzer Zeit zu viele Anfragen gestellt. Bitte versuche es später noch einmal.</mat-error
          >
        }
        @case ('valid') {
          <form class="dt-form" #actualForm="ngForm" [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
            <dt-password-form [newPassword]="true"></dt-password-form>
            @if (passwordForm.getError('server-error') === 'invalid-password') {
              <mat-error i18n>Bitte gib ein Passwort mit mindestens 8 Zeichen an!</mat-error>
            }
            @if (passwordForm.getError('server-error') === 'invalid-token') {
              <mat-error i18n>Der angegebene Link ist ungültig.</mat-error>
            }
            @if (passwordForm.getError('server-error') === 'rate-limit') {
              <mat-error i18n>Du hast in kurzer Zeit zu viele Anfragen gestellt. Bitte versuche es später noch einmal.</mat-error>
            }
            @if (passwordForm.getError('server-error') === 'something') {
              <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten.</mat-error>
            }
            <button
              mat-raised-button
              [dtOverlayProgress]="passwordForm.disabled"
              type="submit"
              color="accent"
              [disabled]="(!passwordForm.valid && !actualForm.submitted) || passwordForm.disabled"
              i18n
              >Passwort ändern</button
            >
          </form>
        }
      }
    }
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button i18n (click)="openLoginModal()" color="accent">Zur Anmeldung</button>
  </ng-template>
</dt-modal-content>

<ng-template #debug>
  <mat-form-field>
    <mat-label>Token Status</mat-label>
    <input matInput [(ngModel)]="tokenStatus" />
  </mat-form-field>
  <mat-checkbox [(ngModel)]="done">Done</mat-checkbox>
</ng-template>
